import styled from "@emotion/styled";
import { Dialog } from "@mui/material";

const StyledBaseDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    margin: 0,
    width: "calc(100% - 8px)",
  },
  "& .MuiDialogActions-root": {
    padding: "5px 25px 25px",
  },
}));

export default StyledBaseDialog;
